import React from 'react';
import { Heart } from 'lucide-react';

const WatchlistButton = ({ movieId, isInWatchlist, onToggle, size = 'default' }) => {
    const sizes = {
        small: 'w-8 h-8',
        default: 'w-10 h-10 sm:w-12 sm:h-12',
        large: 'w-12 h-12 sm:w-14 sm:h-14'
    };

    const iconSizes = {
        small: 'w-4 h-4',
        default: 'w-5 h-5 sm:w-6 sm:h-6',
        large: 'w-6 h-6 sm:w-7 sm:h-7'
    };

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                onToggle(movieId);
            }}
            className={`${sizes[size]} rounded-full backdrop-blur-sm transition-all duration-300 transform hover:scale-110 active:scale-95 flex items-center justify-center group ${
                isInWatchlist
                    ? 'bg-red-600 hover:bg-red-700 shadow-lg shadow-red-500/50'
                    : 'bg-white/20 hover:bg-white/30'
            }`}
            title={isInWatchlist ? 'Retirer des favoris' : 'Ajouter aux favoris'}
        >
            <Heart
                className={`${iconSizes[size]} transition-all duration-300 ${
                    isInWatchlist
                        ? 'text-white fill-current'
                        : 'text-white group-hover:scale-110'
                }`}
            />
        </button>
    );
};

export default WatchlistButton;